import { useAppContext } from 'provider/AppProvider/AppProvider';
// import { useUserContext } from 'provider/UserProvider/UserProvider';
import { FC, useCallback, useState } from 'react';
// import { NavLink, useParams } from 'react-router-dom';
import { NavLink } from 'react-router-dom';
// import { SubTopics as SubTopicsType } from 'services/api/topics';
import useScreen from 'services/hooks/useScreen';
import { useDefaultColorValue } from 'services/queries/app';
// import { useGetSubTopics } from 'services/queries/topics';
import { IFeaturedData } from 'provider/FeaturedProvider/FeaturedProvider.interface';
import DocumentsIcon from 'assets/images/documents.png';
import ActionBlogIcon from 'assets/images/action-blog.png';
import Card from '../ContentList/Card';
import Icon from '../ContentList/Icon';

export interface ContentTypeProps {
  label: string;
  path: string;
  sub_topic: string | undefined;
  display_content: IFeaturedData[] | null | undefined;
  tag_id?: string;
}

// interface IObjectKeys {
//   [key: string]: string;
// }

const TaggedContentTypes: FC<ContentTypeProps> = ({
  label,
  path,
  sub_topic,
  tag_id,
  display_content,
}) => {
  const {
    setup,
    config: { defaultLabels },
    baseURL,
  } = useAppContext();
  const colors = useDefaultColorValue();
  const screen = useScreen();
  const [isMouseEntered, setIsMouseEntered] = useState(false);

  const handleClick = useCallback(() => {
    if (screen === 'mobile') {
      setTimeout(() => {
        const targetEl = document.getElementById(label);
        window.scrollTo({
          behavior: 'smooth',
          top: targetEl?.offsetTop,
        });
      }, 100);
    }
  }, [screen, label]);

  const handleMenuIcon = (type: string) => {
    if (type === 'documents') {
      return (
        <img src={DocumentsIcon} width="32" height="32" alt="Documents Icon" />
      );
    }

    if (type === 'tips') {
      return (
        <img
          src={ActionBlogIcon}
          width="32"
          height="32"
          alt="Action Blog Icon"
        />
      );
    }

    return <Icon type={type} size={32} />;
  };

  const getMenusFromAppSetup = (menuLabel: string) => {
    const currentLabel = label.toLowerCase();
    const setupMenus = setup.header.menu;

    if (setupMenus?.enabled_modules.includes(currentLabel)) {
      if (setupMenus?.label_overrides[currentLabel] !== '') {
        return setupMenus?.label_overrides[currentLabel];
      }
      return defaultLabels[currentLabel];
    }

    return menuLabel;
  };

  // Label overrides, get override for those that support it
  let labelDisplay: string;
  switch (label) {
    case 'Tips':
    case 'Action_lists':
      labelDisplay = getMenusFromAppSetup(label);
      break;
    default:
      labelDisplay = defaultLabels[label.toLowerCase()] ?? label;
      break;
  }

  const toLink = tag_id
    ? `${String(baseURL)}/tag/${String(tag_id)}/${encodeURIComponent(path)}`
    : '#';

  const subTopicsData = display_content;

  return (
    <>
      <NavLink onClick={handleClick} to={toLink}>
        <li
          onMouseEnter={() => setIsMouseEntered(true)}
          onMouseLeave={() => setIsMouseEntered(false)}
          id={label}
          className={`flex items-center gap-4 p-4 ${
            sub_topic === path ? 'bg-white' : 'bg-transparent'
          }`}
          style={{
            color:
              isMouseEntered && decodeURIComponent(String(sub_topic)) !== path
                ? colors.medium
                : colors.dark,
          }}
        >
          <span className="text-black">{handleMenuIcon(path)}</span>
          <span className="uppercase text-[22px]">{labelDisplay}</span>
        </li>
      </NavLink>
      {decodeURIComponent(String(sub_topic)) === path && (
        <div className="px-4 bg-white lg:hidden pb-4 flex flex-col gap-8">
          {(subTopicsData ?? [])?.map((item) => (
            <Card
              id={item.id}
              content_type={path}
              key={item.id}
              title={item.title}
              author={item.author}
              description={item.description}
              image_url={item.image_url}
            />
          ))}
        </div>
      )}
    </>
  );
};

TaggedContentTypes.defaultProps = {
  tag_id: undefined,
};

export default TaggedContentTypes;
